import { render, staticRenderFns } from "./awards_list.vue.js?vue&type=template&id=2af28f70!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./awards_list.vue?vue&type=template&id=2af28f70"
import script from "./awards_list.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./awards_list.vue?vue&type=script&lang=js"
export * from "./awards_list.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./awards_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports